import { Modal } from "antd";
import { useTranslation } from "react-i18next";
import { SuccessLogo } from "../../asset";
import PrimaryButton from "../button/PrimaryButton";

const ModalSuccessAdd = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <Modal
        visible={props.show}
        closable={false}
        centered={true}
        width="298px"
        footer={null}
      >
        <div className="flex flex-col justify-center items-center gap-[9px]">
          <img src={SuccessLogo} alt="" />
          <div className="flex flex-col justify-center items-center">
            <h2 className="font-roboto text-3xl font-bold mb-[16px]">
              {props.title}
            </h2>
            <p className="font-roboto text-[#666666] text-center mb-[16px] font-normal text-lg">
              {props.description}
            </p>
          </div>
        </div>
        <div className="content-center w-[218px] ml-4">
        <PrimaryButton
          text={t("USER_DETAIL:Ok")}
          action={() => props.action()}
          styles="w-[218px] rounded-md"
        />
        </div>
      </Modal>
    </>
  );
};
export default ModalSuccessAdd;
